import api from "../index";

export const LoginApi = (data) => api.post("superadmin-login", data);
export const LoginOtpVeryficationApi = (data) => api.post("superadmin-email-verify", data);
export const ForgotPasswordLinkApi = (data) => api.post("sendforgotlink", data);
export const ResetPasswordApi = (data) => api.post("resetpassword", data);
export const ResendOtpApi = (data) => api.post("superadmin-resend-otp ", data);
export const LogoutApi = () => api.post("logout");
export const CheckBaseUrlApi = () => api.post("get-base-url");
// export const UpdateBaseUrlApi = (data) => api.post("update-base-url", data);
